import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AboutPro, Payment } from '../objects/payment';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  public payment: Observable<Payment>;
  public pro: Observable<AboutPro>;
  private paymentSubject: BehaviorSubject<Payment>;
  private proSubject: BehaviorSubject<AboutPro>;

  constructor() {
    this.paymentSubject = new BehaviorSubject(new Payment());
    this.payment = this.paymentSubject.asObservable();
    this.proSubject = new BehaviorSubject(new AboutPro());
    this.pro = this.proSubject.asObservable();
  }

  public setPaymentState(payment: Payment): void {
    this.paymentSubject.next(payment);
  }

  public setProState(pro: AboutPro) {
    this.proSubject.next(pro);
  }

  public getProState() {
    return this.proSubject.getValue();
  }
}
